import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '../tooltip/tooltip.module';
import { CopyTextToClipboardComponent } from './copy-text-to-clipboard.component';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    TooltipModule
  ],
  declarations: [
    CopyTextToClipboardComponent
  ],
  exports: [
    CopyTextToClipboardComponent
  ]
})
export class CopyTextToClipboardModule {}
